import { ReactElement } from 'react';

import { ValueOfKey } from '../../utils-types';
import { SCORING_RULE, ScoringRuleType } from './scoringRule';

export const LEADERBOARD_COLUMN = {
  RANK: 'RANK',
  CUSTOMER: 'CUSTOMER',
  TOTAL_SCORE: 'TOTAL_SCORE',
  FOOD_TRACKING_PERCENT: 'FOOD_TRACKING_PERCENT',
  FOOD_TRACKING_RANK: 'FOOD_TRACKING_RANK',
  FAT_LOSS_PERCENT: 'FAT_LOSS_PERCENT',
  ADJUSTED_FAT_LOSS_PERCENT: 'ADJUSTED_FAT_LOSS_PERCENT',
  FAT_LOSS_RANK: 'FAT_LOSS_RANK',
  FAT_LOSS_LBS: 'FAT_LOSS_LBS',
  MUSCLE_GAIN_LBS: 'MUSCLE_GAIN_LBS',
  MUSCLE_MULTIPLIER: 'MUSCLE_MULTIPLIER',
  ADJUSTED_SCORE_PERCENT: 'ADJUSTED_SCORE_PERCENT',
} as const;

export type LeaderboardColumn = ValueOfKey<typeof LEADERBOARD_COLUMN>;

export type RenderColumnInfo = Record<LeaderboardColumn, ReactElement | null>;

//This object indicates which columns are visible for each scoring rule type and their ordering
export const columnsConfig: Record<ScoringRuleType, LeaderboardColumn[]> = {
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING]: [
    LEADERBOARD_COLUMN.RANK,
    LEADERBOARD_COLUMN.CUSTOMER,
    LEADERBOARD_COLUMN.TOTAL_SCORE,
    LEADERBOARD_COLUMN.FOOD_TRACKING_PERCENT,
    LEADERBOARD_COLUMN.FOOD_TRACKING_RANK,
    LEADERBOARD_COLUMN.FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.ADJUSTED_FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.FAT_LOSS_RANK,
    LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS,
  ],
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN]: [
    LEADERBOARD_COLUMN.RANK,
    LEADERBOARD_COLUMN.CUSTOMER,
    LEADERBOARD_COLUMN.ADJUSTED_SCORE_PERCENT,
    LEADERBOARD_COLUMN.FAT_LOSS_LBS,
    LEADERBOARD_COLUMN.FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS,
    LEADERBOARD_COLUMN.MUSCLE_MULTIPLIER,
  ],
  [SCORING_RULE.FAT_LOSS]: [
    LEADERBOARD_COLUMN.RANK,
    LEADERBOARD_COLUMN.CUSTOMER,
    LEADERBOARD_COLUMN.FAT_LOSS_PERCENT,
    LEADERBOARD_COLUMN.FAT_LOSS_LBS,
    LEADERBOARD_COLUMN.MUSCLE_GAIN_LBS,
  ],
};
